import * as defaultImport from "@splunk/react-icons/ControlStop";
export * from "@splunk/react-icons/ControlStop";
export default ('default' in defaultImport ? defaultImport.default : defaultImport);
